export const TextField = ({ field, register, errors, theme }) => (
  <input
    id={field.id}
    type={field.type || 'text'}
    {...register(field.id, field.validation)}
    placeholder={field.placeholder}
    className={`${theme.input} ${errors[field.id] ? theme.inputError : ''}`}
    disabled={field.disabled}
    min={field.min}
    max={field.max}
    step={field.step}
  />
);